// extracted by mini-css-extract-plugin
module.exports = {"root":"_2oJTp","responsive-root":"_1PGFM","responsiveRoot":"_1PGFM"};